export const iconFontAwesomeFoodBeverageCandyCane = (
	<i className="fa-solid fa-candy-cane"></i>
);
